import {
  getRecaptchaToken,
  getRecaptchaTokenType,
  showRecaptchaV2Widget,
  isV2WidgetLoaded,
  resetRecaptchaV2
} from "./Common";
import { apiErrorCodes } from "../api/ApiResponse";

export const VIEW_CHALLENGE_ACTION = "view_share_access";
export const PROOF_CHALLENGE_ACTION = "proof_share_access";

export const SHARE_CHALLENGE_OVERLAY_ID = "share-challenge-overlay";

const setOverlayVisible = visible => {
  if (typeof document === "undefined") return;
  const el = document.getElementById(SHARE_CHALLENGE_OVERLAY_ID);
  if (el) el.style.display = visible ? "flex" : "none";
};

let pendingV2Resolve = null;

const handleV2Solved = () => {
  if (!pendingV2Resolve) return;
  const resolve = pendingV2Resolve;
  pendingV2Resolve = null;
  resolve();
};

const waitForV2Check = () => {
  return new Promise(resolve => {
    pendingV2Resolve = resolve;
    if (isV2WidgetLoaded) {
      resetRecaptchaV2();
    } else {
      showRecaptchaV2Widget(handleV2Solved).then(didRender => {
        if (didRender === false) {
          handleV2Solved();
        }
      });
    }
  });
};

const isRecaptchaFailure = apiError => apiError && apiError.errorCode === apiErrorCodes.RECAPTCHA_FAILED;

let inFlightChallenge = null;

const executeShareChallenge = async (action, doPost) => {
  const runOnce = async () => {
    const recaptchaToken = await getRecaptchaToken(action);
    return doPost(recaptchaToken, getRecaptchaTokenType());
  };

  try {
    return await runOnce();
  } catch (apiError) {
    if (!isRecaptchaFailure(apiError)) throw apiError;
    setOverlayVisible(true);
    try {
      await waitForV2Check();
      return await runOnce();
    } finally {
      setOverlayVisible(false);
    }
  }
};

export const runShareChallenge = (action, doPost) => {
  if (inFlightChallenge) return inFlightChallenge;
  const promise = executeShareChallenge(action, doPost).finally(() => {
    if (inFlightChallenge === promise) inFlightChallenge = null;
  });
  inFlightChallenge = promise;
  return promise;
};

export const runViewShareChallenge = doPost => runShareChallenge(VIEW_CHALLENGE_ACTION, doPost);
export const runProofShareChallenge = doPost => runShareChallenge(PROOF_CHALLENGE_ACTION, doPost);
